// extracted by mini-css-extract-plugin
export default {"bottomNav":"BottomNav_bottomNav__3n8uE","item":"BottomNav_item__KrMb9","active":"BottomNav_active__qaMJw","label":"BottomNav_label__IDT7Y","hidden":"BottomNav_hidden__9hzkp"};